import React from "react";
import NormalUserHeader from "../../commons/NormalUserHeader/NormalUserHeader";

const NormalUserLayout = (props) => {
    return (
        <div>
            {/*<NormalUserHeader />*/}
            <div>
                {props.children}
            </div>
            {/* <Footer /> */}
        </div>
    )
}

export default NormalUserLayout;
